import {fetchData, Page} from "../coreSlice";
import {push} from 'connected-react-router';

// This middleware watches the state.filter slice for any changes. If features are toggled that need a
// data refresh, this will detect and respond to those.

let lastFilters = {};
export const filterWatcher = store => next => action => {
	next(action);

	if( action.type.startsWith('filter') ) {
		const state = store.getState();

		const serializedFilters = JSON.stringify(state.filter);
		if( serializedFilters !== JSON.stringify(lastFilters) ) {
			// console.log("FILTERS CHANGED:", lastFilters, state.filter);
			['showPokemon','showRaids','showGyms','showStops','stopShowAll'].forEach(field => {
				if( !lastFilters[field] && state.filter[field] ) {
					// console.log("Toggled on a new feature, need to refresh!");
					store.dispatch(fetchData(false));
				}
			});

			if( lastFilters.pokemonQuality > state.filter.pokemonQuality ) { // It won't update right away
				console.log("Need to grab the lower-quality pokemon...");
				store.dispatch(fetchData(false));
			}
		}

		if( state.core.page !== Page.LIVE )
			return;

		// Next, look at the presets, and navigate to the correct URL
		const currentPreset = state.core.presets.find(preset => preset.filters === serializedFilters);
		if (currentPreset)
			store.dispatch(push(currentPreset.path));
		else
			store.dispatch(push('/'));

		localStorage.setItem('lastFilters', serializedFilters);

		lastFilters = state.filter;
	}
};